module.exports = __webpack_public_path__ + "img/seta-para-esquerda.379943ae.svg";